import React from 'react'

const Spinner = ({ style, cssClass }) => (
    <div className={`${cssClass || ''} spinner`} style={style}>
        <img src={`${process.env.CDN_URL}/includes/images/loading.svg`} alt="loader" />
    </div>
)

export default Spinner
